import { render, staticRenderFns } from "./PersonAddressRow.vue?vue&type=template&id=33be62df&"
import script from "./PersonAddressRow.vue?vue&type=script&lang=js&"
export * from "./PersonAddressRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports